import { Injectable, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';

export type SelectOption = { label: string, value: any };
export type ColorType = 'xls' | 'wheel' | 'legacy' | 'block';
export interface ModalSelectParams {
  handler: AnyHandler;
  options: Array<SelectOption>;
  selected: number;
}

@Injectable({
  providedIn: 'root'
})
export class ModalSelectDialogService {

  public request$: Subject<ModalSelectParams> = new Subject();


  Show(handler: AnyHandler, options: Array<SelectOption>, selected?: number) {
    this.request$.next({
      handler: (handler),
      options: (options),
      selected: (selected)
    });
  }
}
